"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonToggle = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ButtonToggleItem_1 = require("./ButtonToggleItem");
exports.ButtonToggle = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.color, color = _c === void 0 ? 'primary' : _c, primary = _a.primary, negative = _a.negative, className = _a.className, disabled = _a.disabled, _d = _a.el, ButtonToggleElement = _d === void 0 ? 'div' : _d, clearable = _a.clearable, _e = _a.options, options = _e === void 0 ? [] : _e, large = _a.large, small = _a.small, xsmall = _a.xsmall, name = _a.name, _f = _a.size, size = _f === void 0 ? 'medium' : _f, value = _a.value, onChange = _a.onChange, props = __rest(_a, ["color", "primary", "negative", "className", "disabled", "el", "clearable", "options", "large", "small", "xsmall", "name", "size", "value", "onChange"]);
    var _g = react_1.default.useState(value), selected = _g[0], setSelected = _g[1];
    react_1.default.useEffect(function () {
        setSelected(value);
    }, [value]);
    var handleClick = function (select) {
        var realSelected = select !== selected || !clearable ? select : undefined;
        if (onChange)
            onChange(realSelected);
        setSelected(realSelected);
    };
    var copyOptions = function (options) {
        var copiedOptions = options.map(function (option) {
            return {
                text: option.text,
                value: option.value,
                onClick: option.onClick,
                disabled: option.disabled,
                selected: option.selected,
                hidden: option.hidden,
                icon: option.icon,
                iconName: option.iconName,
            };
        });
        return copiedOptions;
    };
    var getOnlySelected = function (options) {
        var isSelected = false;
        var onlyOneSelectedOptions = options.map(function (option) {
            if (option.selected && !isSelected) {
                isSelected = true;
            }
            else {
                option.selected = false;
            }
            return option;
        });
        return onlyOneSelectedOptions;
    };
    var getNormalized = function (options) {
        var realOptions = options.map(function (option) {
            if (disabled)
                option.disabled = disabled;
            if (option.text === undefined)
                option.text = null;
            if (selected !== undefined || clearable)
                option.selected = selected === option.value;
            return option;
        });
        return realOptions;
    };
    var getRealColor = function () {
        var realColor = color;
        if (primary)
            realColor = 'primary';
        if (negative)
            realColor = 'negative';
        return realColor;
    };
    var getButtonToggleItemProps = function (options) {
        var realSize = size;
        // Override string props with boolean values
        if (xsmall)
            realSize = 'xsmall';
        if (small)
            realSize = 'small';
        if (large)
            realSize = 'large';
        var buttonToggleItemProps = options.map(function (option) {
            return {
                name: name,
                text: option.text,
                value: option.value,
                disabled: option.disabled,
                selected: option.selected,
                color: getRealColor(),
                size: realSize,
                hidden: option.hidden,
                onClick: function (value) {
                    if (option.onClick)
                        option.onClick(value);
                    handleClick(value);
                },
                icon: option.icon,
                iconName: option.iconName,
            };
        });
        return buttonToggleItemProps;
    };
    var copiedOptions = copyOptions(options);
    var onlySelectedOptions = getOnlySelected(copiedOptions);
    var normalizedOptions = getNormalized(onlySelectedOptions);
    var buttonToggleItemProps = getButtonToggleItemProps(normalizedOptions);
    var contents = buttonToggleItemProps.map(function (buttonProp, index) {
        return react_1.default.createElement(ButtonToggleItem_1.ButtonToggleItem, __assign({ key: index }, buttonProp));
    });
    var realColor = getRealColor();
    var ButtonToggleClasses = classnames_1.default('ButtonToggle', className, (_b = {
            'ButtonToggle--disabled': disabled
        },
        _b["ButtonToggle--" + realColor] = realColor,
        _b));
    return (react_1.default.createElement(ButtonToggleElement, __assign({ ref: ref, className: ButtonToggleClasses }, props), contents));
});
//# sourceMappingURL=ButtonToggle.js.map